import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgbNavItem, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared.module';
import { GridUsersListModule } from '../../views/grid-user-list/grid-users-list.module';
import { SortElementsModule } from '../../views/sort-elements/sort-elements.module';
import { AdminService } from './admin.service';
import { AdminsListComponent } from './admins/admins-list/admins-list.component';
import { AdminsComponent } from './admins/admins.component';
import { CategoryService } from './category/category.service';
import { ManageCategoriesComponent } from './category/manage-categories/manage-categories.component';
import { DeactivatedUsersModule } from './deactivated-users/deactivated-users.module';

@NgModule({
  imports: [SharedModule, DeactivatedUsersModule, SortElementsModule, NgbPaginationModule, GridUsersListModule],
  declarations: [AdminsComponent, AdminsListComponent, ManageCategoriesComponent],
})
export class AdminModule {
  public static forRoot(): ModuleWithProviders<AdminModule> {
    return {
      ngModule: AdminModule,
      providers: [AdminService, NgbNavItem, CategoryService],
    };
  }
}
